(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const deferredAutoplayMedia = document.querySelectorAll('deferred-media[data-vspots-deferred-autoplay]');
  const media = document.querySelector('.product-information .product-information__media');
  const details = document.querySelector('.product-information .product-details');
  const content = document.querySelector('.vspots-product-content');
  const contentGrid = content?.querySelector('.vspots-product-content__grid');
  const sideColumn = content?.querySelector('.vspots-product-content__side-column');
  const distanceBadge = document.querySelector('[data-vspots-product-partner-distance]');

  const positionStorageKeys = [
    'vspots_geo_manual_location_v2',
    'vspots_geo_position_v3',
    'vspots_geo_position_v2',
  ];

  const hasCoordinates = (latitude, longitude) =>
    Number.isFinite(latitude) &&
    Number.isFinite(longitude) &&
    latitude >= 34 &&
    latitude <= 72 &&
    longitude >= -25 &&
    longitude <= 45;

  const readStoredPosition = () => {
    for (const storageKey of positionStorageKeys) {
      try {
        const position = JSON.parse(window.localStorage.getItem(storageKey));
        const latitude = Number(position?.latitude);
        const longitude = Number(position?.longitude);
        if (hasCoordinates(latitude, longitude)) return { latitude, longitude };
      } catch {
        continue;
      }
    }

    return null;
  };

  const distanceInKilometers = (origin, destination) => {
    const earthRadius = 6371;
    const toRadians = (degrees) => (degrees * Math.PI) / 180;
    const latitudeDelta = toRadians(destination.latitude - origin.latitude);
    const longitudeDelta = toRadians(destination.longitude - origin.longitude);
    const originLatitude = toRadians(origin.latitude);
    const destinationLatitude = toRadians(destination.latitude);
    const haversine =
      Math.sin(latitudeDelta / 2) ** 2 +
      Math.cos(originLatitude) * Math.cos(destinationLatitude) * Math.sin(longitudeDelta / 2) ** 2;

    return earthRadius * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
  };

  const formatDistance = (distance) => {
    if (distance < 1) {
      return `${Math.max(100, Math.round((distance * 1000) / 100) * 100)} m`;
    }

    return `${new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      maximumFractionDigits: distance < 10 ? 1 : 0,
    }).format(distance)} km`;
  };

  const renderProductDistance = (position = readStoredPosition()) => {
    if (!distanceBadge || !position) return;

    const latitude = Number(distanceBadge.dataset.vspotsProductLatitude);
    const longitude = Number(distanceBadge.dataset.vspotsProductLongitude);
    if (!hasCoordinates(latitude, longitude)) return;

    const formattedDistance = formatDistance(
      distanceInKilometers(position, { latitude, longitude })
    );

    distanceBadge.textContent = formattedDistance;
    distanceBadge.hidden = false;
    distanceBadge.setAttribute(
      'aria-label',
      (distanceBadge.dataset.vspotsProductDistanceLabel || '__DISTANCE__ entfernt').replace(
        '__DISTANCE__',
        formattedDistance
      )
    );
  };

  renderProductDistance();
  window.addEventListener('vspots:location-changed', (event) => {
    const latitude = Number(event.detail?.latitude);
    const longitude = Number(event.detail?.longitude);
    if (hasCoordinates(latitude, longitude)) {
      renderProductDistance({ latitude, longitude });
    }
  });

  const initializeDeferredAutoplay = async () => {
    if (deferredAutoplayMedia.length === 0) return;
    await window.customElements.whenDefined('deferred-media');

    const play = (element) => {
      if (element.hasAttribute('data-media-loaded')) return;
      element.showDeferredMedia?.();
    };

    if (!('IntersectionObserver' in window)) {
      deferredAutoplayMedia.forEach(play);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          play(entry.target);
        });
      },
      { rootMargin: '100px 0px', threshold: 0.2 }
    );
    deferredAutoplayMedia.forEach((element) => observer.observe(element));
  };

  if (document.readyState === 'complete') initializeDeferredAutoplay();
  else window.addEventListener('load', initializeDeferredAutoplay, { once: true });

  if (!media || !details || !content || !contentGrid || !sideColumn) return;

  let animationFrame;

  const alignColumns = () => {
    window.cancelAnimationFrame(animationFrame);
    animationFrame = window.requestAnimationFrame(() => {
      if (!desktop.matches) {
        content.style.removeProperty('--vspots-product-column-offset');
        content.style.removeProperty('--vspots-product-side-width');
        return;
      }

      const offset = Math.max(0, Math.round(details.getBoundingClientRect().height - media.getBoundingClientRect().height));
      const sideWidth = Math.max(
        0,
        Math.round((contentGrid.getBoundingClientRect().right - details.getBoundingClientRect().left) * 10) / 10
      );
      content.style.setProperty('--vspots-product-column-offset', `${offset}px`);
      content.style.setProperty('--vspots-product-side-width', `${sideWidth}px`);
    });
  };

  const observer = new ResizeObserver(alignColumns);
  observer.observe(media);
  observer.observe(details);
  observer.observe(contentGrid);

  desktop.addEventListener('change', alignColumns);
  window.addEventListener('load', alignColumns, { once: true });
  document.fonts?.ready.then(alignColumns);
  alignColumns();
})();
